import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center text-center py-16 md:py-20 px-4 rounded-lg border border-dashed border-background-300 bg-background-100/60">
      <span className="w-14 h-14 rounded-full bg-background-200 flex items-center justify-center text-foreground-500">
        <i className={`${icon} text-2xl`} aria-hidden="true" />
      </span>
      <h3 className="mt-4 text-base font-medium text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-5 inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base" aria-hidden="true" />
        </Link>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line text-base" aria-hidden="true" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}